// extracted by mini-css-extract-plugin
export default {"container":"container___rRJwx","fadeIn":"fadeIn___kPi64","subTitle":"subTitle___Z0KxW","alertNote":"alertNote___I8crw","signButton":"signButton___Np6u3","saveForLater":"saveForLater___zscnL","linkButton":"linkButton___seoOn","modalBody":"modalBody___BoNOK","content":"content___OfGDp","loader":"loader___TuvWA","saveLaterLink":"saveLaterLink___fASKZ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"container___rRJwx\",\"fadeIn\":\"fadeIn___kPi64\",\"subTitle\":\"subTitle___Z0KxW\",\"alertNote\":\"alertNote___I8crw\",\"signButton\":\"signButton___Np6u3\",\"saveForLater\":\"saveForLater___zscnL\",\"linkButton\":\"linkButton___seoOn\",\"modalBody\":\"modalBody___BoNOK\",\"content\":\"content___OfGDp\",\"loader\":\"loader___TuvWA\",\"saveLaterLink\":\"saveLaterLink___fASKZ\"}";
        // 1793018519395
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  